export default function () {
  document.addEventListener('preloader:done', () => {
    const videos = document.querySelectorAll('.js-hero-video');

    if (videos.length) {
      videos.forEach((video) => {
        video.play();
      });
    }
  });
}
